export default "__VITE_ASSET__UE2Mmvyd__"